<template>
    <div class="card">
        <div v-if="$can('view','task_category')" class="row">
            <Toast />
            <DataTable :value="all_task_categories" :paginator="true" :rows="10"
            :paginatorTemplate="paginatorTemplate"
            :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll" scrollable 
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            stripedRows :loading="loading"
            :globalFilterFields="['name']"
            v-model:filters="filters"  >
                <template #header>
                    <div class="table-header flex flex-column md:flex-row md:justify-content-end">
                        <span class="p-input-icon-left ">
                            <i class="pi pi-search" />
                            <InputText id="filter_task_categories" v-model="filters['global'].value" placeholder="Keyword Search" class="input_small"/>
                        </span>
                    </div>
                </template>
                <Column header="Name" field="name" :sortable="true"/>
                <Column v-if="$can('change','task_category')" header="Edit" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button data-cy="edit_button" icon="pi pi-pencil" class="p-button-rounded p-button-info p-button-outlined" @click="edit_task_category(slotProps.data)"/>
                    </template>
                </Column>
                <Column v-if="$can('delete','task_category')" header="Delete" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button data-cy="delete_button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-outlined" @click="confirm_delete_task_category(slotProps)"/>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <Dialog data-cy="edit_task_category_modal" v-model:visible="task_category_dialog" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}" header="Task category Details" :modal="true" class="p-fluid">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="name" class="ps-1 pb-1"> <strong>Name</strong> </label>
                        <InputText id="name" v-model.trim="task_category.name" required="true" autofocus :class="{'p-invalid': submitted && !task_category.name || task_category_errors.name}" />
                        <small class="p-error" v-if="submitted && !task_category.name">Name is required.</small>
                        <small v-if="Object.keys(task_category_errors).length !== 0 && task_category_errors.name" class="p-error"><span v-for="error in task_category_errors.name" :key="error">{{error}}<br></span></small>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Cancel" class="p-button-text" @click="hide_task_category_dialog"/>
            <Button data-cy="save_edit_task_category" label="Save" @click="save_task_category" />
        </template>
    </Dialog>

    <Dialog v-model:visible="delete_task_category_dialog" :style="{width: '450px'}" header="Confirm" :modal="true">
        <div class="confirmation-content">
            <span v-if="task_category">Are you sure you want to delete <b>{{task_category.name}}</b>?</span>
        </div>
        <template #footer>
            <Button label="No" class="p-button-text" @click="delete_task_category_dialog = false"/>
            <Button data-cy="confirm_delete_button" label="Yes" @click="deleteTask_category" />
        </template>
    </Dialog>

</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button'
import InputText from 'primevue/inputtext';
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import { FilterMatchMode } from 'primevue/api';
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core";

export default {
    setup: () => ({ v$: useVuelidate() }),
    name: 'TableTask_categories',
    components: {
        DataTable,
        Column,
        Button,
        InputText,
        Toast,
        Dialog
    },
    data() {
        return {
            task_category: {},
            task_category_errors:{},
            task_category_dialog: false,
            delete_task_category_dialog: false,
            submitted: false,
            filters: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            },
            loading: false,
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        }
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        if(this.all_task_categories.length == 0) {
            this.loading = true
            await this.$store.dispatch('load_all_task_categories')
            this.loading = false
        }
        
    },

    async unmounted(){
        window.removeEventListener('resize', this.handleResize);
    },

    computed: {
        all_task_categories: function() {
            return this.$store.getters.all_task_categories
        },
        get_errors_task_category: function(){
            return this.$store.getters.get_errors_task_category
        },
        get_delete_task_category_status: function() {
            return this.$store.getters.get_delete_task_category_status
        }
    },
    methods: {

        async handleResize(){
            if (window.innerWidth <= 767){
                this.paginatorTemplate = "CurrentPageReport PrevPageLink NextPageLink"
            } else {
                this.paginatorTemplate = "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            }
        },

        confirm_delete_task_category(task_category) {
            this.task_category = task_category.data;
            this.delete_task_category_dialog = true;
        },
        async deleteTask_category() {
            await this.$store.dispatch('delete_task_category', this.task_category.id)
            if (!this.get_delete_task_category_status){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Task category deleted', life: 3000});    
            }else{
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'error', summary: 'Error', detail: "Task category can't be deleted", life: 3000});
            }
            this.delete_task_category_dialog = false;
        },
        edit_task_category(task_category) {
            this.task_category = {...task_category};
            this.task_category_dialog = true;
        },
        async save_task_category() {
            this.submitted = true;
			if (this.task_category.name.trim()) {

                await this.$store.dispatch('update_task_category', this.task_category)
                this.task_category_errors = this.get_errors_task_category
                
                if(Object.keys(this.task_category_errors).length === 0){
                    this.hide_task_category_dialog();
                    this.task_category = {};
                    this.$toast.removeAllGroups();
                    this.$toast.add({severity:'success', summary: 'Successful', detail: 'Task category modified', life: 3000});
                }
            }
        },
        hide_task_category_dialog() {
            this.task_category_dialog = false;
            this.submitted = false;
        },
    },
    validations() {
        return {
            name: { required }
        }
    },
}
</script>

<style scoped>
.card {
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
    border-radius: 10px;
    margin-bottom: 1rem;
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}

:deep(.p-inputtext){
    font-size: 1rem;
    margin: auto;
}

.input_small{
    font-size: .8rem !important; 
}

</style>